/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { message, InputNumber, Spin } from "antd";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { boatApi } from "../../apis";

const EditDeck = () => {
  const { id } = useParams();
  const history = useHistory();
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [form, setForm] = useState({ name: "", capacity: 50, defaultAdultPrice: 500, defaultChildPrice: 250 });

  useEffect(() => {
    boatApi.getDeck(id)
      .then(d => setForm({ 
        name: d.name || "", 
        capacity: d.capacity, 
        defaultAdultPrice: d.defaultAdultPrice,
        defaultChildPrice: d.defaultChildPrice 
      }))
      .catch(() => message.error("Failed to load deck"))
      .finally(() => setFetching(false));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return message.error("Name is required");
    try {
      setLoading(true);
      await boatApi.updateDeck(id, form);
      message.success("Deck updated");
      history.push("/boat/decks");
    } catch (e) {
      message.error(e.response?.data?.message || "Failed to update");
    } finally { setLoading(false); }
  };

  if (fetching) return (
    <div className="main-wrapper"><Header onMenuClick={() => {}} /><Sidebar />
      <div className="page-wrapper"><div className="content container-fluid">
        <div style={{ textAlign: "center", padding: 80 }}><Spin size="large" /></div>
      </div></div>
    </div>
  );

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5>Edit Deck</h5>
                  <button type="button" className="btn btn-primary cancel me-2" onClick={() => history.goBack()}>Back</button>
                </div>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-group-item">
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="input-block mb-3">
                        <label>Deck Name <span className="text-danger">*</span></label>
                        <input className="form-control" value={form.name}
                          onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required disabled={loading} />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-6">
                      <div className="input-block mb-3">
                        <label>Capacity (seats)</label>
                        <InputNumber style={{ width: "100%" }} min={1} value={form.capacity}
                          onChange={v => setForm(f => ({ ...f, capacity: v }))} disabled={loading} />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>Adult Price (EGP)</label>
                        <InputNumber style={{ width: "100%" }} min={1} value={form.defaultAdultPrice}
                          onChange={v => setForm(f => ({ ...f, defaultAdultPrice: v }))} disabled={loading} />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>Child Price (EGP)</label>
                        <InputNumber style={{ width: "100%" }} min={1} value={form.defaultChildPrice}
                          onChange={v => setForm(f => ({ ...f, defaultChildPrice: v }))} disabled={loading} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group-item border-0">
                  <div className="text-end">
                    <button type="button" className="btn btn-primary cancel me-2" onClick={() => history.goBack()} disabled={loading}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? (<><span className="spinner-border spinner-border-sm me-2" />Saving…</>) : "Save Changes"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDeck;
